export const formatSeconds = (value: number) => {
  const seconds = value % 60;

  const totalMinutes = value === seconds ? 0 : (value - seconds) / 60;

  const minutes = totalMinutes % 60;

  const hours = totalMinutes === minutes ? 0 : (totalMinutes - minutes) / 60;

  return { hours, minutes, seconds };
};

export default formatSeconds;
